export default () => ({

    open: false,

    init() {

    	this.$watch('open', () => {

	    	if(this.open == true)
	   		{
		   		this.$el.style.height = this.$refs.content.offsetHeight + 'px';

		        setTimeout(() => {
		          	this.$el.style.height = 'auto';
		        }, 400)
		    }
    	})
    },

	toggle(){

	    this.open = true;
	    this.$dispatch('notify');

    }

});
